module.exports = __webpack_public_path__ + "img/blur_1.3ff230da.jpg";